/* src/app/modules/portal/components/service-tickets-page/service-tickets-page.component.scss */
:host {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}
sh-card {
  overflow: hidden;
  height: 100%;
}
sh-table-cell sh-icon {
  display: inline;
  position: absolute;
  margin-left: 100px;
}
.menu {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.container {
  display: flex;
  flex-direction: column;
}
.reset-filters {
  margin: 10px;
}
sh-table-row:not(:first-child) {
  margin-bottom: 3px;
}
sh-table-cell {
  align-items: baseline;
}
sh-table-cell span {
  margin-top: -5px;
}
[screen-phone] :host-context .menu {
  margin-top: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
}
[screen-phone] :host-context .menu > * {
  width: calc(50% - 0.5rem);
}
[screen-phone] :host-context .menu sh-search {
  width: calc(100% - 100px);
}
[screen-phone] :host-context .menu #refresh {
  width: initial;
}
[screen-phone] :host-context .menu .reset-filters {
  display: none;
}
.ticket-indicator {
  border-left: solid;
  border-left-width: thick;
}
.ticket-indicator[color=yellow] {
  border-color: #ffd201;
}
.ticket-indicator[color=green] {
  border-color: #009a38;
}
.ticket-indicator[color=red] {
  border-color: #e7001d;
}
.ticket-indicator[color=grey] {
  border-color: #808080;
}
.ticket-count-row {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}
/*# sourceMappingURL=service-tickets-page.component.css.map */
